const ValidateOdooCompanyView = ({ odooCompany, wisCompany }) => {
  console.log("ValidateOdooCompanyView", { odooCompany, wisCompany });

  let error;
  if (!odooCompany) {
    if (wisCompany !== "UNSET") {
      error = `Odoo company is not set, but WIS company is set to ${wisCompany}. Please correct the Odoo company or WIS company.`;
    }
  } else {
    if (odooCompany === 1 && wisCompany !== "AB") {
      error = `Odoo company is set to AB, but WIS company is set to ${wisCompany}. Please correct the Odoo company or WIS company.`;
    } else if (odooCompany === 3 && wisCompany !== "LTD") {
      error = `Odoo company is set to LTD, but WIS company is set to ${wisCompany}. Please correct the Odoo company or WIS company.`;
    }
  }

  if (!error) return null;

  return <div className="font-semibold text-red-500">⚠️ {error}</div>;
};

export default ValidateOdooCompanyView;
